import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Shirdiroundtripcabbooking() {



    const cardData = {





keyword: "Shirdi Round Trip Cab Booking",
headingDescription: "Sai Shirdi Cab provides reliable round trip cab booking in Shirdi for travelers who need private transportation for both onward and return journeys. Round trip taxi service is suitable for families, devotees, couples, senior citizens, business travelers, and small groups planning temple visits, weekend holidays, sightseeing tours, airport transfers, and outstation trips from Shirdi. Booking a round trip cab allows passengers to travel in the same vehicle according to a planned itinerary, making transportation between destinations easier to coordinate. Sai Shirdi Cab offers flexible round trip arrangements for short-distance and long-distance routes, including one-day travel, multi-day trips, pilgrimage tours, and customized sightseeing plans. Customers can select a suitable vehicle according to passenger count and luggage requirements, while pickup and return timings can be organized around the planned travel schedule. Whether you are visiting a nearby religious destination or planning a longer Maharashtra tour, round trip cab booking provides a convenient and organized private travel option.",

topPlaces: [
{
title: "Mahabaleshwar",
description: "Mahabaleshwar is a suitable destination for a round trip cab journey from Shirdi for families, couples, friends, and leisure travelers. Sai Shirdi Cab can arrange a private vehicle for the complete onward and return journey, allowing passengers to follow their own sightseeing schedule. Round trip booking is particularly useful for travelers planning a day trip, weekend stay, or multi-day hill-station itinerary."
},
{
title: "Shani Shingnapur",
description: "Shani Shingnapur is an important pilgrimage destination that can be conveniently covered through round trip cab booking from Shirdi. Devotees and families can travel in a private taxi, complete their temple visit, and return to Shirdi according to their planned schedule. Sai Shirdi Cab can arrange the journey with suitable pickup and return timings for a comfortable religious trip."
},
{
title: "Bhimashankar",
description: "Bhimashankar is a popular choice for devotees planning a religious round trip from Shirdi. With Sai Shirdi Cab, passengers can book a private cab for the complete journey and avoid arranging separate transportation for the return. The itinerary can be customized for temple visits, sightseeing stops, family travel, and additional pilgrimage destinations."
},
{
title: "Nashik",
description: "Nashik offers a flexible round trip travel option from Shirdi for pilgrimage, sightseeing, business visits, and family journeys. Sai Shirdi Cab can arrange a private taxi that remains available according to the planned itinerary and return schedule. Travelers can also include additional religious or sightseeing stops around Nashik when booking a customized round trip."
},
{
title: "Trimbakeshwar",
description: "Trimbakeshwar is an excellent destination for devotees looking for a round trip cab from Shirdi. Sai Shirdi Cab can arrange private transportation for passengers who want to complete their temple visit and return to Shirdi in the same vehicle. The trip can be organized according to preferred departure times, sightseeing requirements, and the duration of the pilgrimage."
},
{
title: "Bhandardara",
description: "Bhandardara is a good option for families and groups planning a nature-focused round trip from Shirdi. A private cab from Sai Shirdi Cab allows travelers to enjoy the journey without depending on separate transportation at the destination. The round trip can be planned for a day excursion, weekend outing, or longer stay with flexible sightseeing arrangements."
},
{
title: "Goa",
description: "Goa is a long-distance destination suitable for travelers planning an extended round trip from Shirdi for vacations, family holidays, celebrations, and group travel. Sai Shirdi Cab can arrange private cab transportation for the complete journey, allowing passengers to plan their return according to their stay. Multi-day round trip arrangements can include sightseeing and other planned stops along the route."
},
{
title: "Ajanta-Ellora Caves",
description: "Ajanta-Ellora Caves are ideal for travelers planning a heritage sightseeing tour from Shirdi with return transportation included. Sai Shirdi Cab can arrange a private round trip cab for families, couples, students, and small groups who want flexibility while exploring historical attractions. The itinerary can be customized according to sightseeing time and preferred return schedule."
},
{
title: "Saputara",
description: "Saputara is a scenic option for a round trip cab journey from Shirdi for travelers looking for a relaxing hill-station getaway. Sai Shirdi Cab can provide private transportation for families and small groups with a planned return journey to Shirdi. The trip can be arranged around sightseeing, overnight stays, and the preferred duration of the holiday."
},
{
title: "Pune",
description: "Pune is an important outstation destination for travelers planning business trips, family visits, educational travel, events, or extended sightseeing from Shirdi. Sai Shirdi Cab offers round trip cab booking so passengers can travel to Pune and return to Shirdi according to a pre-planned schedule. The journey can also include additional stops when a customized multi-destination itinerary is required."
}
]
,







"services": [
{
"name": "Shirdi Round Trip Cab Booking",
"description": "Sai Shirdi Cabs provides convenient Shirdi round trip cab booking for devotees, families, and travelers planning return journeys from Shirdi. Reserve a suitable vehicle for local or outstation travel and enjoy comfortable transportation for both onward and return trips."
},
{
"name": "Shirdi Round Trip Taxi Booking",
"description": "Book a Shirdi round trip taxi for a convenient journey with transportation arranged in both directions. Sai Shirdi Cabs offers suitable taxi options for pilgrimage trips, family travel, business journeys, and sightseeing plans."
},
{
"name": "Shirdi round trip cab service",
"description": "Our Shirdi round trip cab service is designed for travelers who want a comfortable vehicle available for their complete journey. From short outstation visits to longer pilgrimage routes, Sai Shirdi Cabs provides practical cab options according to your travel requirements."
},
{
"name": "Shirdi round trip taxi service",
"description": "Sai Shirdi Cabs offers reliable Shirdi round trip taxi service for passengers who need convenient transportation from Shirdi to their destination and back. Enjoy a dedicated taxi arrangement that makes return travel easier to plan."
},
{
"name": "round trip cab booking in Shirdi",
"description": "Choose round trip cab booking in Shirdi for convenient two-way transportation without arranging separate vehicles for your return journey. Sai Shirdi Cabs provides comfortable cars for families, devotees, groups, and travelers visiting nearby cities and pilgrimage destinations."
},
{
"name": "round trip taxi booking in Shirdi",
"description": "Round trip taxi booking in Shirdi is a practical option for travelers planning a fixed return journey. Sai Shirdi Cabs offers suitable taxi choices for outstation trips, temple visits, sightseeing tours, and family travel."
},
{
"name": "Shirdi round trip outstation cab",
"description": "Travel beyond Shirdi with a dedicated round trip outstation cab from Sai Shirdi Cabs. Keep the same vehicle for your onward and return journey, making it convenient for pilgrimage tours, family trips, business travel, and destination visits."
},
{
"name": "Shirdi round trip outstation taxi",
"description": "Sai Shirdi Cabs provides Shirdi round trip outstation taxi services for travelers who prefer planned transportation throughout their journey. Our outstation taxi options are suitable for individuals, families, and groups traveling to cities and religious destinations."
},
{
"name": "Shirdi round trip car rental",
"description": "Book a Shirdi round trip car rental for convenient travel when your itinerary includes both departure and return journeys. Sai Shirdi Cabs offers comfortable car options for sightseeing, pilgrimage trips, family travel, and outstation requirements."
},
{
"name": "Shirdi round trip cab with driver",
"description": "Choose a Shirdi round trip cab with driver for a relaxed journey without the responsibility of driving yourself. Sai Shirdi Cabs provides driver-assisted cab options for families, devotees, and groups who want convenient transportation throughout their complete trip."
},
{
"name": "Shirdi to Mumbai round trip cab",
"description": "Book a Shirdi to Mumbai round trip cab for a convenient journey between Shirdi and Mumbai with return transportation arranged in advance. Sai Shirdi Cabs offers comfortable vehicles for business travel, family visits, airport connections, and personal trips."
},
{
"name": "Shirdi to Pune round trip cab",
"description": "Sai Shirdi Cabs provides Shirdi to Pune round trip cab services for passengers who need transportation to Pune and back to Shirdi. This option is suitable for families, professionals, students, and devotees looking for a convenient two-way journey."
},
{
"name": "Shirdi to Nashik round trip cab",
"description": "Travel from Shirdi to Nashik and return comfortably with a dedicated round trip cab from Sai Shirdi Cabs. The service is suitable for sightseeing, business visits, family travel, and religious journeys where return transportation is required."
},
{
"name": "Shirdi to Aurangabad round trip cab",
"description": "Plan a convenient Shirdi to Aurangabad round trip cab journey with Sai Shirdi Cabs. Keep your transportation arranged for both directions and enjoy a comfortable travel option for family trips, sightseeing, business requirements, and personal visits."
},
{
"name": "Shirdi to Goa round trip cab",
"description": "Sai Shirdi Cabs offers Shirdi to Goa round trip cab services for travelers planning an extended journey with a return trip to Shirdi. Spacious vehicle options can make the long-distance journey more comfortable for families and groups."
},
{
"name": "Shirdi to Pandharpur round trip cab",
"description": "Book a Shirdi to Pandharpur round trip cab for a convenient pilgrimage journey with return transportation included. Sai Shirdi Cabs provides suitable vehicles for devotees and families who want a comfortable and organized two-way trip."
},
{
"name": "Shirdi to Trimbakeshwar round trip cab",
"description": "Travel conveniently from Shirdi to Trimbakeshwar and back with a dedicated round trip cab from Sai Shirdi Cabs. This service is suitable for devotees planning temple visits and travelers who prefer having transportation available for their return journey."
},
{
"name": "Shirdi to Shani Shingnapur round trip cab",
"description": "Sai Shirdi Cabs provides Shirdi to Shani Shingnapur round trip cab services for devotees planning a convenient religious trip. A dedicated vehicle allows passengers to travel comfortably between the two destinations while keeping their return transportation arranged."
},
{
"name": "Shirdi Innova round trip cab",
"description": "The Shirdi Innova round trip cab is a suitable choice for families and groups seeking spacious and comfortable transportation for a two-way journey. Sai Shirdi Cabs offers Innova vehicles for outstation trips, pilgrimage tours, and extended travel plans."
},
{
"name": "Shirdi Ertiga round trip cab",
"description": "Book a Shirdi Ertiga round trip cab when you need a comfortable and spacious vehicle for your complete journey. Sai Shirdi Cabs provides Ertiga options for families and small groups traveling from Shirdi to outstation destinations and returning after their trip."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs offers reliable round trip cab and taxi services from Shirdi for local, outstation, pilgrimage, sightseeing, and family travel. With Sedan, Ertiga, Innova, and other suitable vehicle options, passengers can arrange convenient two-way transportation according to their itinerary."
}
],
"tableData": [
["Shirdi Round Trip Cab Booking", "Shirdi Round Trip Taxi Booking"],
["Shirdi round trip cab service", "Shirdi round trip taxi service"],
["round trip cab booking in Shirdi", "round trip taxi booking in Shirdi"],
["Shirdi round trip outstation cab", "Shirdi round trip outstation taxi"],
["Shirdi round trip car rental", "Shirdi round trip cab with driver"],
["Shirdi to Mumbai round trip cab", "Shirdi to Pune round trip cab"],
["Shirdi to Nashik round trip cab", "Shirdi to Aurangabad round trip cab"],
["Shirdi to Goa round trip cab", "Shirdi to Pandharpur round trip cab"],
["Shirdi to Trimbakeshwar round trip cab", "Shirdi to Shani Shingnapur round trip cab"],
["Shirdi Innova round trip cab", "Shirdi Ertiga round trip cab"],
["Sai Shirdi Cabs", "Shirdi Round Trip Cab Booking"]
]
,





whychoose: [  
 
    {   
 
        WhyChooseheading: "Shirdi Round Trip Cab Booking for Complete Travel Convenience",   
 
        WhyChoosedescription: "Sai Shirdi Cabs provides Shirdi Round Trip Cab Booking services for devotees, families, tourists, senior citizens, and groups planning to travel from Shirdi to another destination and return. A private round trip cab can be arranged according to your travel date, pickup location, destination, return schedule, passenger count, luggage requirements, and overall journey plan."   
 
    },   
 
    {   
 
        WhyChooseheading: "Private Taxi for Shirdi Round Trip Travel",   
 
        WhyChoosedescription: "Travellers can arrange a private taxi for round trip journeys starting from Shirdi and returning to Shirdi after completing their planned visit. Sai Shirdi Cabs can coordinate both onward and return travel requirements, making the service suitable for pilgrimage tours, family trips, sightseeing plans, and outstation journeys."   
 
    },   
 
    {   
 
        WhyChooseheading: "Round Trip Cab for Sai Baba Pilgrimage",   
 
        WhyChoosedescription: "Devotees travelling to Shirdi as part of a larger pilgrimage can arrange round trip transportation with a private cab. The journey can be planned around temple visits, sightseeing stops, accommodation arrangements, and return requirements, helping passengers manage their complete travel schedule without arranging separate transportation for the return journey."   
 
    },   
 
    {   
 
        WhyChooseheading: "Shirdi Round Trip Taxi for Families and Groups",   
 
        WhyChoosedescription: "Families and small groups can choose a private round trip taxi when travelling together from Shirdi to another city or sightseeing destination. Sharing the passenger count, luggage requirements, travel dates, and return schedule helps in planning transportation that accommodates the group's complete journey requirements."   
 
    },   
 
    {   
 
        WhyChooseheading: "Round Trip Cab with Planned Return Journey",   
 
        WhyChoosedescription: "A round trip booking allows passengers to plan both the departure from Shirdi and their return journey in advance. Sai Shirdi Cabs can arrange the transportation details according to the selected destination, return date, preferred timings, passenger requirements, luggage, and overall itinerary."   
 
    },   
 
    {   
 
        WhyChooseheading: "Shirdi Round Trip Cab for Outstation Trips",   
 
        WhyChoosedescription: "Travellers planning an outstation journey from Shirdi can arrange a round trip cab for destinations such as Pune, Mumbai, Nashik, Aurangabad, Ahmednagar, and other locations. The service can be discussed according to the planned route, travel duration, destination, return schedule, passenger count, and luggage requirements."   
 
    },   
 
    {   
 
        WhyChooseheading: "Round Trip Taxi for Shirdi Sightseeing and Travel Plans",   
 
        WhyChoosedescription: "Passengers combining Shirdi pilgrimage with local sightseeing or nearby destination visits can plan their complete transportation through a round trip taxi. The itinerary can be discussed according to the places you want to visit, preferred travel timings, pickup and return locations, passenger details, and available travel duration."   
 
    },   
 
    {   
 
        WhyChooseheading: "Book Shirdi Round Trip Cab with Sai Shirdi Cabs",   
 
        WhyChoosedescription: "To book a Shirdi Round Trip Cab, contact Sai Shirdi Cabs with your pickup location, destination, travel date, return date, preferred departure and return timings, passenger count, luggage information, and other requirements. Providing complete journey details helps in organizing the round trip transportation according to your travel plans."   
 
    }   
 
]   
 
 
}; 
 
const faqData = [ 
 
{ 
 
question: "Can I book a round trip cab from Shirdi?", 
 
answer: "Yes, Sai Shirdi Cabs provides private round trip cab services from Shirdi for devotees, families, tourists, senior citizens, and groups travelling to selected destinations and returning to Shirdi." 
 
}, 
 
{ 
 
question: "What is a Shirdi Round Trip Cab Booking?", 
 
answer: "A Shirdi Round Trip Cab Booking includes transportation for the onward journey from Shirdi to your selected destination along with the planned return journey according to your travel schedule." 
 
}, 
 
{ 
 
question: "Can I book a round trip taxi for a pilgrimage?", 
 
answer: "Yes, devotees can arrange a round trip taxi for pilgrimage travel and plan transportation around temple visits, sightseeing stops, accommodation, destination requirements, and the return schedule." 
 
}, 
 
{ 
 
question: "Can families book a Shirdi Round Trip Cab?", 
 
answer: "Yes, families can book a private round trip cab from Shirdi and provide their passenger count, luggage details, destination, travel dates, and preferred return schedule during booking." 
 
}, 
 
{ 
 
question: "Can I travel to another city and return to Shirdi by the same cab?", 
 
answer: "Yes, a round trip cab can be arranged for travelling from Shirdi to your selected destination and returning to Shirdi according to the agreed travel schedule and journey requirements." 
 
}, 
 
{ 
 
question: "Which destinations can I cover with a Shirdi round trip cab?", 
 
answer: "You can discuss destinations such as Pune, Mumbai, Nashik, Aurangabad, Ahmednagar, and other locations with Sai Shirdi Cabs based on your preferred route and round trip travel plan." 
 
}, 
 
{ 
 
question: "Can I include sightseeing during a Shirdi round trip?", 
 
answer: "Yes, sightseeing requirements can be discussed while planning the round trip cab, including selected attractions, travel duration, pickup points, destination stops, and return schedule." 
 
}, 
 
{ 
 
question: "Can I travel with luggage in a Shirdi round trip taxi?", 
 
answer: "Yes, passengers can travel with luggage, and providing luggage details along with the passenger count helps in planning the vehicle arrangement according to the complete journey requirements." 
 
}, 
 
{ 
 
question: "Can I choose the return date for a Shirdi round trip cab?", 
 
answer: "Yes, you can provide your preferred return date and timing along with the onward travel details so the round trip transportation can be planned around your itinerary." 
 
}, 
 
{ 
 
question: "How can I book a Shirdi Round Trip Cab?", 
 
answer: "You can contact Sai Shirdi Cabs with your Shirdi pickup location, destination, travel date, return date, preferred timings, passenger count, luggage information, and other journey requirements to arrange your round trip cab booking." 
 
} 
 
]; 
 
const testimonials = [ 
 
{ 
 
id: 1, 
 
name: "Mr. Aditya More", 
 
feedback: "Our family needed transportation for a complete trip from Shirdi and back. The round trip cab arrangement made the journey easier to coordinate, especially with our luggage and return plans already decided before we started travelling.", 
 
rating: 5 
 
}, 
 
{ 
 
id: 2, 
 
name: "Mrs. Ritu Deshpande", 
 
feedback: "For our pilgrimage itinerary, having the return journey planned along with the onward trip was very convenient. Sai Shirdi Cabs helped us organize the cab according to our travel schedule, and the private vehicle worked well for our group.", 
 
rating: 5 
 
} 
 
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Shirdi Round Trip Cab Booking",
  "image": "https://www.saishirdicabs.com/assets/images/shirdi-round-trip-cab-booking.webp",
  "description":
    "Book a Shirdi Round Trip Cab with Sai Shirdi Cabs for comfortable, convenient, and reliable round-trip travel. Our round trip cab service is suitable for Sai Baba Darshan, local sightseeing, family trips, pilgrimage travel, business travel, and outstation journeys. Get well-maintained cars, professional drivers, flexible pickup and drop locations, affordable fares, and easy booking assistance for round trips from Shirdi to Mumbai, Pune, Nashik, Aurangabad, and other destinations.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/shirdi-round-trip-cab-booking"
  }
};





    return (
        <div>



<Helmet>
  <title>Shirdi Round Trip Cab Booking | Round Trip Taxi | +91 7776814559</title>

  <meta
    name="description"
    content="Book a Shirdi Round Trip Cab with Sai Shirdi Cabs for comfortable and reliable travel. Get professional drivers, well-maintained cars, affordable fares and easy booking for Shirdi sightseeing, Sai Baba Darshan and outstation round trips."
  />

  <meta
    name="keywords"
    content="Shirdi Round Trip Cab Booking, Shirdi Round Trip Taxi Booking, Shirdi round trip cab service, Shirdi round trip taxi service, round trip cab booking in Shirdi, round trip taxi booking in Shirdi, Shirdi round trip outstation cab, Shirdi round trip outstation taxi, Shirdi round trip car rental, Shirdi round trip cab with driver, Shirdi to Mumbai round trip cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/109.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Shirdiroundtripcabbooking;